export default __webpack_public_path__ + "static/media/gallery_01.73475bf3.jpg";